import logo from './logo.svg';
import './App.css';
import axios from 'axios';
import { HashRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Home } from './pages/home';
import { Layout } from './components/layout';
import { useState, createContext } from 'react';
import { RoadMap } from './pages/roadmap';
export const QuestionContext = createContext();

function App() {
  const [activeButton, setActiveButton] = useState(null);
  
  return (
    <QuestionContext.Provider value = {{activeButton, setActiveButton}}>
    <HashRouter>
      <Routes>
        <Route path = "/" element = {<Layout></Layout>}>
          <Route index element ={<Home/>}/>
          <Route path = "/:slug" element ={<RoadMap/>}/>
        </Route>
      </Routes>
    </HashRouter>
    </QuestionContext.Provider>

  );
}

export default App;
